/*
 * Public API Surface of ngx-split-view
 */

export * from './lib/split-view.component';
export * from './lib/split-view.module';
